import { render, staticRenderFns } from "./ed-split-horizontal.vue?vue&type=template&id=47eebed0&scoped=true&"
import script from "./ed-split-horizontal.ts?vue&type=script&lang=ts&"
export * from "./ed-split-horizontal.ts?vue&type=script&lang=ts&"
import style0 from "./ed-split-horizontal.scss?vue&type=style&index=0&id=47eebed0&lang=scss&scoped=true&"
import style1 from "../../styles/split-objects.scss?vue&type=style&index=1&id=47eebed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eebed0",
  null
  
)

export default component.exports